import { render } from "./NetworkError.vue?vue&type=template&id=cbabbe56"
const script = {}
script.render = render

export default script